export function getMaritalStatusOptions(localized) {
  return [
    {
      label: (localized && localized['maritalStatus.single']) || 'Single',
      value: 'single'
    },
    {
      label: (localized && localized['maritalStatus.married']) || 'Married',
      value: 'married'
    },
    {
      label: (localized && localized['maritalStatus.divorced']) || 'Divorced',
      value: 'divorced'
    },
    {
      label: (localized && localized['maritalStatus.widowed']) || 'Widowed',
      value: 'widowed'
    },
    {
      label: (localized && localized['maritalStatus.separated']) || 'Separated',
      value: 'separated'
    },
    {
      label: (localized && localized['maritalStatus.domestic']) || 'Domestic',
      value: 'domestic'
    }
  ];
}

export const maritalStatusNumberMap = {
  0: 'single',
  1: 'married'
};

export const maritalStatusStringMap = {
  single: 0,
  married: 1
};
